<section class="horizon-card">
  <header class="horizon-card__head">
    <h3 class="horizon-card__title">Buyer Interest Insights <span class="bi-ai">AI</span></h3>
  </header>

  <div class="horizon__state" *ngIf="isLoading && !insights"><i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Loading insights…</div>
  <div class="horizon__state horizon__state--error" *ngIf="hasLoadError">The insights could not be loaded.</div>

  <!-- Only the lot-based rows need lot views; the AI insight below reads all of the buyer's activity, so it still shows. -->
  <p class="horizon__empty" *ngIf="!isLoading && !hasLoadError && !insights?.available">
    No lot views in this period yet, so there is no preferred configuration, floor or price range to show.
  </p>

  <ng-container *ngIf="insights?.available">
    <div class="bi">
      <ul class="bi-rows" *ngIf="hasAnyRow">
        <li *ngIf="insights.preferred_configuration as config">
          <i class="fa-solid fa-bed bi-rows__icon" aria-hidden="true"></i>
          <span>
            <small>Preferred configuration</small>
            <strong>{{ config.label }}</strong>
          </span>
        </li>
        <li *ngIf="insights.preferred_floors as floors">
          <i class="fa-solid fa-building bi-rows__icon" aria-hidden="true"></i>
          <span>
            <small>Most viewed floors</small>
            <strong>{{ floors.label }}</strong>
          </span>
        </li>
        <li *ngIf="insights.price_range_viewed as range">
          <i class="fa-solid fa-dollar-sign bi-rows__icon" aria-hidden="true"></i>
          <span>
            <small>Price range viewed</small>
            <strong>{{ range.label }}</strong>
          </span>
        </li>
        <li *ngIf="topPropertyType">
          <i class="fa-solid fa-table-cells-large bi-rows__icon" aria-hidden="true"></i>
          <span>
            <small>Property types viewed most</small>
            <strong>{{ topPropertyType }}</strong>
          </span>
        </li>
      </ul>

      <div class="bi-level" *ngIf="insights.engagement as engagement">
        <small>Engagement level</small>
        <strong class="bi-level__value" [ngClass]="'bi-level__value--' + engagement.level">
          <i class="fa-solid fa-fire" aria-hidden="true"></i> {{ engagement.level | titlecase }}
        </strong>
        <small *ngIf="engagement.note">{{ engagement.note }}</small>
      </div>
    </div>
  </ng-container>

  <div class="bi-ai-box" *ngIf="!isLoading && !hasLoadError" [class.bi-ai-box--neutral]="ai.status !== 'ok'">
    <strong class="bi-ai-box__title"><i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i> AI Insight</strong>
    <ng-container [ngSwitch]="ai.status">
      <ng-container *ngSwitchCase="'ok'">
        <p>{{ ai.text }}</p>
        <p class="bi-ai-box__action" *ngIf="ai.recommended_action"><strong>Next step:</strong> {{ ai.recommended_action }}</p>
      </ng-container>
      <p *ngSwitchCase="'insufficient_data'">{{ ai.text || 'There is not enough Horizon activity in this period to suggest a next step.' }}</p>
      <p *ngSwitchDefault>The AI insight is not available right now. The figures above are still correct.</p>
    </ng-container>
  </div>
</section>
